import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import API_BASE_URL from "./config/api";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Load user from localStorage on mount
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));

    if (storedUser?.token) {
      try {
        const decodedToken = jwtDecode(storedUser.token);
        if (decodedToken.exp * 1000 > Date.now()) {
          setUser(storedUser); // Token is still valid
        } else {
          logout(); // If token expired, clear storage and logout
        }
      } catch (error) {
        console.error("Error decoding token:", error);
        logout();
      }
    }

    setLoading(false);
  }, []);

  // Login function
  const login = async (employeeId, password) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/auth.php`,
        { employeeId, password }
      );

      if (response.data.success) {
        const userData = {
          token: response.data.token,
          id: response.data.id,
          employeeId: response.data.employee_id,
          userType: response.data.userType,
          role: response.data.role,
          name: response.data.name,
        };

        localStorage.setItem("user", JSON.stringify(userData));

        // Restore last seen timestamp OR set new timestamp if first login
        const lastSeen = Date.now(); // Always update last seen to current time
        localStorage.setItem("lastSeen", lastSeen);

        setUser(userData);
        return { success: true };
      } else {
        return { success: false, message: response.data.message };
      }
    } catch (error) {
      return { success: false, message: "Login failed" };
    }
  };

  // Logout function
  const logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("reminderShown"); // Clear reminder flag
    localStorage.removeItem("lastSeen"); // Reset last seen timestamp
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
